import { createContext } from 'react';

const alertDialogContext = createContext();

export default alertDialogContext;
